import { agreementTranslations } from './agreements';
import { commonTranslations } from './common';
import { componentTranslations } from './components';
import { routeTranslations } from './routes';
import { questionTranslations } from './questions';
import { notificationTranslations } from './notifications';
import { formSectionsTranslations } from './formSections';
import { surveyTranslations } from './surveys';

export default {
    agreementTranslations,
    commonTranslations,
    componentTranslations,
    routeTranslations,
    questionTranslations,
    notificationTranslations,
    formSectionsTranslations,
    surveyTranslations
};
